module.exports = __webpack_public_path__ + "fonts/SEGOEPRB.07ae95ea.TTF";